import { miningPower as miningPowerStore } from "../domain/store";
export function calcMiningPower(collectionsStaking, poolConfig) {
    return collectionsStaking
        .filter((cs) => poolConfig.has(cs.collection))
        .map((cs) => {
        const collectionConfig = poolConfig.get(cs.collection);
        let miningPower = 0;
        if (cs.collection === "s.rplanet") {
            miningPower = cs.staked / 10000;
        }
        else {
            const poolRewards = Number((collectionConfig === null || collectionConfig === void 0 ? void 0 : collectionConfig.fraction.split(" ")[0]) || 0);
            miningPower =
                (cs.staked * poolRewards) / ((collectionConfig === null || collectionConfig === void 0 ? void 0 : collectionConfig.staked) || 0);
        }
        return Object.assign(Object.assign({}, cs), { miningPower });
    });
}
export function getRank(mp) {
    if (mp < 2000) {
        return "🐠";
    }
    if (mp < 10000) {
        return "🦀";
    }
    if (mp < 40000) {
        return "🐬";
    }
    if (mp < 100000) {
        return "🦈";
    }
    if (mp < 250000) {
        return "🐳";
    }
    return "🐙";
}
export function calcTotals(collectionsStaking) {
    let collected = 0;
    let miningPower = 0;
    collectionsStaking.forEach((cs) => {
        collected += Number(cs.collected.split(" ")[0]);
        miningPower += cs.miningPower || 0;
    });
    miningPowerStore.set(miningPower);
    return { collected, miningPower };
}
